import React, { useState, useEffect, useMemo } from 'react';
import { Box, useDisclosure } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';
import Cookies from 'js-cookie';
import { languageMapping } from '../../../../i18n/config';
import GameMarqueeIconButton from './GameMarqueeIconButton';
import GameMarqueeModal from './GameMarqueeModal';

const GameMarquee = ({ gameConfig = {} }) => {
  const { gameUid } = useParams();
  const gameMarqueeList = useSelector((state) => state.isGameMarqueeList);
  const { isOpen, onOpen, onClose } = useDisclosure();

  // 根據 gameUid 與 語言過濾公告
  const filteredMarquees = useMemo(() => {
    if (!gameMarqueeList || !Array.isArray(gameMarqueeList)) return [];

    const currentLng = languageMapping(i18next.language) || 'zh_TW';
    const uid = Number(gameUid);

    return gameMarqueeList.reduce((acc, item) => {
      // 優先取得當前語系資料，若無則看 item 本身
      let data = item[currentLng] || item;

      // 如果當前語系內容為空，且有 en_US 資料，則回退至 en_US
      if (!data.content && item['en_US']) {
        data = item['en_US'];
      }

      const gameUids = data.game_uids || [];

      if (gameUids.includes(uid)) {
        acc.push({
          ...data,
          marquee_id: item.marquee_id || data.marquee_id // 確保有 id
        });
      }
      return acc;
    }, []);
  }, [gameMarqueeList, gameUid]);

  // 進場自動彈窗邏輯
  useEffect(() => {
    if (filteredMarquees.length > 0) {
      // 檢查是否所有公告都已經被標記為隱藏
      const hasUnshownMarquee = filteredMarquees.some(
        (item) => !Cookies.get(`hide_game_marquee_${item.marquee_id}`)
      );

      if (hasUnshownMarquee) {
        onOpen();
      }
    }
  }, [filteredMarquees, onOpen]);

  // 如果沒有公告就不渲染
  if (filteredMarquees.length === 0) return null;

  return (
    <Box position="absolute" top={0} right={0} zIndex={100} p={2}>
      <GameMarqueeIconButton onClick={onOpen} />
      <GameMarqueeModal
        isOpen={isOpen}
        onClose={onClose}
        marquees={filteredMarquees}
      />
    </Box>
  );
};

export default GameMarquee;
